import Component from './setting_user_notifications.vue'
export default Component
